import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';
import SlideDetail from 'src/components/medicalSchema/SlideDetail';
import ListDetail from 'src/components/medicalSchema/ListDetail';

const MedicalSchema = () => {
  const breadcrumbs = [
    <Link
      underline='hover'
      key='1'
      color='primary.main'
      component={RouterLink}
      to='/'
      fontSize={'14px'}
      fontWeight={400}
    >
      会計
    </Link>,
    <Link
      underline='hover'
      key='2'
      color='primary.main'
      component={RouterLink}
      to='/'
      fontSize={'14px'}
      fontWeight={400}
    >
      見積一覧
    </Link>,
    <Typography key='3' color='#656D78' fontWeight={400}>
      患者履歴
    </Typography>,
  ];
  return (
    <>
      <Breadcrumbs
        separator={
          <Box
            component='img'
            src='/images/icons/ic-arrow-right-breadcrumb.svg'
            alt='icon'
          />
        }
        aria-label='breadcrumb'
        sx={{
          '& .MuiBreadcrumbs-li': { lineHeight: '14px' },
          '& .MuiBreadcrumbs-separator': { mx: '2px' },
        }}
      >
        {breadcrumbs}
      </Breadcrumbs>
      <Typography
        fontSize={'20px'}
        fontWeight={500}
        color={'primary.dark'}
        mt={'18px'}
        mb={'16px'}
      >
        患者情報
      </Typography>
      <Stack direction={'row'} spacing={'20px'} width={'auto'}>
        <SlideDetail />
        <ListDetail />
        <Box
          width={'20px'}
          sx={{ backgroundColor: 'transparent', display: { xl: 'none' } }}
        >
          &nbsp;
        </Box>
      </Stack>
    </>
  );
};

export default MedicalSchema;
